import { render, staticRenderFns } from "./SettingEmployeeRegister.vue?vue&type=template&id=68db06ba&scoped=true&"
import script from "./SettingEmployeeRegister.vue?vue&type=script&lang=ts&"
export * from "./SettingEmployeeRegister.vue?vue&type=script&lang=ts&"
import style0 from "./SettingEmployeeRegister.vue?vue&type=style&index=0&id=68db06ba&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68db06ba",
  null
  
)

export default component.exports